const userUtils = {
  isRep(roles: string[]): boolean {
    return roles.indexOf('rep') > -1;
  },
  isAdmin(roles: string[]): boolean {
    return roles.indexOf('admin') > -1;
  },
  isPostingPathAdmin(roles: string[] = []): boolean {
    if (roles === null) {
      return false;
    }
    return roles.indexOf('postingPathAdmin') > -1;
  },
  isMultiFamilyCustomer(roles: string[] = []): boolean {
    if (roles === null) {
      return false;
    }
    return roles.indexOf('multifamilyCustomer') > -1;
  },
};

export default userUtils;
